import { Organizer } from "../../../types/OrganizerTypes"
import { BuyerParty } from "../../../../modules/payments/orderTypes"
import { MonetaryAmount } from "../../../../modules/currency/currencyTypes"
import {
    DeliveryFulfillmentType,
    DynamicConfigKey,
    PaymentMethodOptionValue,
} from "../../createOrder/components/form/formTypes"
import { BillReceiverEndpointMS, BillReceiversItemContactDetails, OrderLineType } from "../../createOrder/createOrderTypes"
import { BillReceiversType } from "../../billReceivers/billReceiverTypes"

type Payment = Readonly<{
    buyerCustomerParty?: {
        id: number
    }
    method: PaymentMethodOptionValue | string
    accounting?: {
        dimensions: AccountingDimension[]
    }
}>

type AccountingDimension = Readonly<{
    id: number
}>

export enum DeliveryLocationType {
    RESOURCE = "RESOURCE",
    OTHER_LOCATION = "OTHER_LOCATION",
}

export type DeliveryLocationInfo =
    | Readonly<{
          type: DeliveryLocationType.RESOURCE
          resourceId: number
      }>
    | Readonly<{
          type: DeliveryLocationType.OTHER_LOCATION
          name: string
      }>

export type MeetingServiceOrderDetailsDelivery = Readonly<{
    deliveryLocation?: DeliveryLocationInfo
    deliveryTime: string //  "2020-08-20T10:00"
    orderLines: ReadonlyArray<MeetingServiceOrderLine>
    type: DeliveryFulfillmentType
    seats: number
    satellite?: { id: number }
}>

export type MeetingServiceOrderLine =
    | Readonly<{
          productId?: number
          items: number
          buyerParty: BuyerParty
          priceListId?: number
      }>
    | Readonly<{
          type: DynamicConfigKey.PRODUCT_WISH
          productName: string
          items: number
          price?: MonetaryAmount
          buyerParty: BuyerParty
      }>
    | Readonly<{
          type: OrderLineType.EXTRA_SERVICE
          productId: number
          items: number
          buyerParty: BuyerParty
      }>

type MeetingDetails = Readonly<{
    meetingName: string
    startDateTime?: string // ISO DateTime e.g. "2021-02-10 12:30:00"
    endDateTime?: string
    attendees: Attendee[]
    organizers: Organizer[]
    recurrence?: {
        pattern: string
    }
}>
export type Attendee = Readonly<{
    company: string
    name: string
    isExternal: boolean
}>

export type MeetingServiceOrderDetails = Readonly<{
    order?: { id: number }
    merchant: { id: number }
    priceList: { id: number }
    webshop: { id: number }
    payment: Payment
    deliveries: MeetingServiceOrderDetailsDelivery[]
    meetingDetails: MeetingDetails
    orderNote: string
    orderType: "MEETING_SERVICE" | string
}>

// Bill Receiver

export type BillReceiver = Readonly<{
    id: number
    type: BillReceiversType
    name: string
    vatnumber?: string
    address?: {
        displayName: string
        country?: { countryCode: string; name: string }
        postalCode?: string
        city?: string
        addressLines?: string[]
    }
    endpoint?: BillReceiverEndpointMS
    isActive?: boolean
    contactDetails?: BillReceiversItemContactDetails
}>
